module.exports = __webpack_public_path__ + "static/media/transferencias.43d4ac94.svg";